/**
 * filterCriteria
 *
 * This function takes a filterForm object, a product object, and a page string as arguments.
 * It constructs a filterCriteria object based on the provided arguments.
 * The filterCriteria object is then returned after filtering out any properties with falsy values.
 *
 * @param {Object} filterForm - The form data used for filtering.
 * @param data
 * @param {string} page - The current page context (e.g., 'comments', 'products', etc.).
 * @return {Object} - The constructed filterCriteria object with non-falsy values.
 */
export const filterCriteria = (filterForm, data, page) => {
    const filterCriteria = {};

    // Check if the page is 'comments' and set the filter criteria accordingly
    if (page === 'comments') {
        if (filterForm) {
            filterCriteria.productId = data?.productId;
            filterCriteria.clearanceMemoTitleId = data?.clearanceMemoTitleId;
            filterCriteria.commentType = filterForm?.commentType
                ? filterForm.commentType.value
                : '';
            filterCriteria.bodyText = filterForm.bodyText;
            filterCriteria.publicPrivate = filterForm.publicPrivate;
        }
    }

    // Check if the page is 'products' and set the filter criteria accordingly
    if (page === 'products') {
        filterCriteria.productId = filterForm.productId;
        filterCriteria.productTitle = filterForm.productTitle;
        filterCriteria.classFilter = filterForm.classFilter ? filterForm.classFilter?.value : '';
        filterCriteria.loadStatus = filterForm.loadStatus ? filterForm.loadStatus?.value : '';
        filterCriteria.legalStatusId = filterForm.legalStatusId
            ? filterForm.legalStatusId?.value
            : '';
        filterCriteria.startYear = filterForm.startYear;
        filterCriteria.endYear = filterForm.endYear;
        filterCriteria.foxFinancialTitleId = data.foxFinancialTitleId;
    }

    // Check if the page is 'clearanceMemos' and set the filter criteria accordingly
    if (page === 'clearanceMemoTitles') {
        filterCriteria.foxFinancialTitleId = filterForm.foxFinancialTitleId;
        filterCriteria.title = filterForm.title;
        filterCriteria.productType = filterForm.productType;
        filterCriteria.legalStatusId = filterForm.legalStatusId
            ? filterForm.legalStatusId?.value
            : '';
        filterCriteria.keywords = filterForm.keywords;
        filterCriteria.clearanceMemoMapped = filterForm.clearanceMemoMapped.value;
        filterCriteria.clearanceMemoImported = filterForm.clearanceMemoImported.value;
        filterCriteria.foxipediaId = filterForm.foxipediaId;
        filterCriteria.lifeCycleStatus = filterForm.lifeCycleStatus;
    }

    // Check if the page is 'sharedSections' and set the filter criteria accordingly
    if (page === 'sharedSections') {
        filterCriteria.title = filterForm.title;
        filterCriteria.bodyText = filterForm.bodyText;
        filterCriteria.publicPrivate = filterForm?.publicPrivate && [
            filterForm.publicPrivate.value.toLocaleLowerCase(),
        ];
        filterCriteria.id = filterForm?.id ? filterForm.id[0].value : '';
    }

    // Check if the page is 'tags' and set the filter criteria accordingly
    if (page === 'tags') {
        filterCriteria.q = filterForm.name;
    }

    // Check if the page is 'contacts' and set the filter criteria accordingly
    if (page === 'contacts') {
        filterCriteria.name = filterForm.name;
    }

    // Filter out any properties with empty values from the filterCriteria object
    return Object.fromEntries(Object.entries(filterCriteria).filter(([unused, value]) => value));
};
